module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9f4cec21dfeee10b255f0362d165d383.gif";